<div role="tree">
  <input [ngStyle]="HIDDEN_STYLE" />
</div>
<div class="ant-tree-list" [class.ant-select-tree-list]="nzSelectMode">
  <div>
    <cdk-virtual-scroll-viewport
      *ngIf="nzVirtualHeight"
      [class.ant-select-tree-list-holder-inner]="nzSelectMode"
      [class.ant-tree-list-holder-inner]="!nzSelectMode"
      [itemSize]="nzVirtualItemSize"
      [minBufferPx]="nzVirtualMinBufferPx"
      [maxBufferPx]="nzVirtualMaxBufferPx"
      [style.height]="nzVirtualHeight">
      <ng-container *cdkVirtualFor="let node of nzFlattenNodes; trackBy: trackByFlattenNode">
        <ng-template [ngTemplateOutlet]="nodeTemplate" [ngTemplateOutletContext]="{ $implicit: node }"></ng-template>
      </ng-container>
    </cdk-virtual-scroll-viewport>

    <div *ngIf="!nzVirtualHeight" [class.ant-select-tree-list-holder-inner]="nzSelectMode" [class.ant-tree-list-holder-inner]="!nzSelectMode">
      <ng-container *ngFor="let node of nzFlattenNodes; trackBy: trackByFlattenNode">
        <ng-template [ngTemplateOutlet]="nodeTemplate" [ngTemplateOutletContext]="{ $implicit: node }"></ng-template>
      </ng-container>
    </div>
  </div>
</div>
<ng-template #nodeTemplate let-treeNode>
  <ui-tree-node
    builtin
    [icon]="treeNode.icon"
    [title]="treeNode.title"
    [isLoading]="treeNode.isLoading"
    [isSelected]="treeNode.isSelected"
    [isDisabled]="treeNode.isDisabled"
    [isMatched]="treeNode.isMatched"
    [isExpanded]="treeNode.isExpanded"
    [isLeaf]="treeNode.isLeaf"
    [isStart]="treeNode.isStart"
    [isEnd]="treeNode.isEnd"
    [isChecked]="treeNode.isChecked"
    [isHalfChecked]="treeNode.isHalfChecked"
    [isDisableCheckbox]="treeNode.isDisableCheckbox"
    [isSelectable]="treeNode.isSelectable"
    [canHide]="treeNode.canHide"
    [uiTreeNode]="treeNode"
    [uiSelectMode]="nzSelectMode"
    [uiShowLine]="nzShowLine"
    [uiExpandedIcon]="nzExpandedIcon"
    [uiDraggable]="nzDraggable"
    [uiCheckable]="nzCheckable"
    [uiShowExpand]="nzShowExpand"
    [uiAsyncData]="nzAsyncData"
    [uiSearchValue]="nzSearchValue"
    [uiHideUnMatched]="nzHideUnMatched"
    [uiBeforeDrop]="nzBeforeDrop"
    [uiShowIcon]="nzShowIcon"
    [uiTreeTemplate]="nzTreeTemplate || nzTreeTemplateChild"
    (uiExpandChange)="eventTriggerChanged($event)"
    (uiClick)="eventTriggerChanged($event)"
    (uiDblClick)="eventTriggerChanged($event)"
    (uiContextMenu)="eventTriggerChanged($event)"
    (uiCheckBoxChange)="eventTriggerChanged($event)"
    (uiOnDragStart)="eventTriggerChanged($event)"
    (uiOnDragEnter)="eventTriggerChanged($event)"
    (uiOnDragOver)="eventTriggerChanged($event)"
    (uiOnDragLeave)="eventTriggerChanged($event)"
    (uiOnDragEnd)="eventTriggerChanged($event)"
    (uiOnDrop)="eventTriggerChanged($event)"></ui-tree-node>
</ng-template>
